/**
 * The hand-drawn underline that marks the accent phrase in a hero headline.
 *
 * Extracted from HomePageB so the marketing pages share one definition instead of
 * copying the path data. It is the strongest single piece of the brand's display
 * treatment — heavy Space Grotesk with this amber stroke sketched underneath — and
 * a second, slightly-different copy would read as a different product.
 *
 * The SVG is decorative: aria-hidden, and deliberately carries NO <title> child.
 * A <title> inside a heading gets concatenated into the heading's text content,
 * which is how "Your complete German exam prep course." once reached Google as
 * "…prep course.underline".
 */
import React from 'react';
import { motion } from 'framer-motion';

const draw = {
  hidden: { pathLength: 0, opacity: 0 },
  visible: {
    pathLength: 1,
    opacity: 1,
    transition: {
      pathLength: { duration: 2.5, ease: [0.43, 0.13, 0.23, 0.96] },
      opacity: { duration: 0.5 },
    },
  },
};

export default function HandDrawnLine({ children }) {
  return (
    <span className="relative inline-block">
      {children}
      <motion.svg
        viewBox="0 0 300 16"
        className="absolute -bottom-1 left-0 w-full h-4 pointer-events-none"
        preserveAspectRatio="none"
        initial="hidden"
        animate="visible"
        aria-hidden
      >
        <motion.path
          d="M 4 11 C 40 5, 80 13, 130 7 C 180 3, 220 12, 260 6 C 275 5, 290 9, 296 8"
          fill="none"
          stroke="#d97706"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity="0.45"
          variants={draw}
        />
      </motion.svg>
    </span>
  );
}
